import { Button, Typography } from '@breetometer/components';
import { StatusIcon } from 'BreetAssets';

export const ErrorPage = ({
	title,
	description,
	cta,
}: {
	title?: string;
	description?: string;
	cta?: { title?: string; action: () => void };
}) => (
	<div className='error-page'>
		<StatusIcon status='unsuccessful' />
		<Typography
			as='h4'
			className='color-neutral-50'
		>
			{title ?? 'Something went wrong'}
		</Typography>
		<Typography className='color-primary-100'>{description ?? 'Please try again later'}</Typography>
		{cta?.action && (
			<Button
				variant='danger'
				onClick={cta.action}
				className='border-dark-navy color-tertiary-400'
			>
				{cta.title ?? 'Close'}
			</Button>
		)}
	</div>
);
